import { environment } from "@env/environment";
import {
	AngularCommonsLibelleConfiguration,
	CommonsConfigurationService,
} from "@jack-sparrow-libraries/angular-business-commons";
import { Injectable } from "@angular/core";

@Injectable()
export class CommonsConfigurationAgatheyouService implements CommonsConfigurationService {
	getUrlBackend(): string {
		return environment.apiEmotion();
	}
	getCpsBloqueLink(): string {
		return ""; //ne sert pas pour le moment
	}
	getLibelleConfig(): AngularCommonsLibelleConfiguration {
		return {
			ordonnance: "ordonnance",
			app: "Agatheyou",
		};
	}
}
